import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "About Us", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[#8E7CC3]/15 bg-white/80 backdrop-blur-md" data-testid="navbar">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="#top" className="flex items-center" data-testid="nav-logo" aria-label="Glow & Shine Sisters Cleaning Co. home">
          <img
            src="/logo.png"
            alt="Glow & Shine Sisters Cleaning Co."
            className="h-[4.25rem] w-auto sm:h-20"
          />
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#2C2A35] transition-colors hover:text-[#674EA7]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="tel:+18563080562"
            data-testid="nav-call-button"
            className="flex items-center gap-2 rounded-full border border-[#D4AF37]/50 px-5 py-2.5 text-sm font-semibold text-[#2C2A35] transition-transform hover:scale-[1.02]"
          >
            <Phone className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" />
            (856) 308-0562
          </a>
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="rounded-full bg-[#8E7CC3] px-6 py-2.5 text-sm font-bold text-white shadow-[0_8px_30px_rgb(142,124,195,0.35)] transition-transform hover:scale-[1.02]"
          >
            Get a Free Quote
          </a>
        </div>

        <button
          className="lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-[#8E7CC3]/10 bg-white px-6 py-4 lg:hidden" aria-label="Mobile navigation" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block py-3 text-base font-medium text-[#2C2A35]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-quote-button"
            className="mt-2 block rounded-full bg-[#8E7CC3] px-6 py-3 text-center text-sm font-bold text-white"
          >
            Get a Free Quote
          </a>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
